import {
  breakpointsTailwind,
  useBreakpoints as vUseBreakpoints
} from '@vueuse/core'

export const useBreakpoints = () => {
  // Initialize with SSR-safe defaults
  // On server: default to desktop view (safer assumption)
  // On client: will hydrate with actual breakpoint
  const breakpoints = vUseBreakpoints(breakpointsTailwind)

  const isDesktop = computed(() => {
    // SSR: default to true (desktop)
    if (typeof window === 'undefined') return true
    return breakpoints.greaterOrEqual('lg').value
  })

  const isMobile = computed(() => {
    // SSR: default to false (not mobile)
    if (typeof window === 'undefined') return false
    return breakpoints.smaller('lg').value
  })

  return {
    isDesktop,
    isMobile
  }
}
